import { OpenFeatureProvider } from "@openfeature/react-sdk";
import React from "react";

function FeatureFlagProvider({ children }: { children?: React.ReactNode }) {
  return <OpenFeatureProvider>{children}</OpenFeatureProvider>;
}

export { FeatureFlagProvider };
